(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["floating-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('floating-product-video')) {
    customElements.define(
      'floating-product-video',
      class FloatingProductVideo extends HTMLElement {
        connectedCallback() {
          var self = this;
          this.expanded = false;
          this.storageKey = 'floating-video-closed:' + (this.dataset.productHandle || '');

          var inEditor = window.Shopify && window.Shopify.designMode;
          if (!inEditor && this.wasClosed()) {
            this.hidden = true;
            return;
          }

          this.video = this.querySelector('video');
          this.closeButton = this.querySelector('[data-close]');
          this.expandButton = this.querySelector('[data-expand]');

          if (this.video) {
            this.video.muted = true;
            this.video.loop = true;
            this.video.controls = false;
            this.video.setAttribute('playsinline', '');
            if (this.dataset.autoplay === 'true') this.play();
          }

          this.onCloseClick = function (event) {
            event.stopPropagation();
            if (self.expanded) self.collapse();
            else self.dismiss();
          };
          this.onExpandClick = function () {
            self.expand();
          };
          this.onKeydown = function (event) {
            if (event.key === 'Escape' && self.expanded) self.collapse();
          };

          if (this.closeButton) this.closeButton.addEventListener('click', this.onCloseClick);
          if (this.expandButton) this.expandButton.addEventListener('click', this.onExpandClick);
          document.addEventListener('keydown', this.onKeydown);
        }

        disconnectedCallback() {
          if (this.onKeydown) document.removeEventListener('keydown', this.onKeydown);
        }

        play() {
          if (!this.video) return;
          var promise = this.video.play();
          if (promise && typeof promise.catch === 'function') promise.catch(function () {});
        }

        expand() {
          if (this.expanded) return;
          this.expanded = true;
          this.classList.add('is-expanded');
          if (this.expandButton) this.expandButton.setAttribute('aria-expanded', 'true');
          if (this.closeButton) this.closeButton.setAttribute('aria-label', 'Minimize video');
          if (this.video) {
            this.video.muted = false;
            this.video.controls = true;
            this.play();
          }
        }

        collapse() {
          if (!this.expanded) return;
          this.expanded = false;
          this.classList.remove('is-expanded');
          if (this.expandButton) this.expandButton.setAttribute('aria-expanded', 'false');
          if (this.closeButton) this.closeButton.setAttribute('aria-label', 'Close video');
          if (this.video) {
            this.video.muted = true;
            this.video.controls = false;
            this.play();
          }
        }

        dismiss() {
          this.hidden = true;
          if (this.video) this.video.pause();
          try {
            sessionStorage.setItem(this.storageKey, '1');
          } catch (error) {}
        }

        wasClosed() {
          try {
            return sessionStorage.getItem(this.storageKey) === '1';
          } catch (error) {
            return false;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
